module.exports = __webpack_public_path__ + "img/landing_renewal.86b693b8.svg";